function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.9165,
  y: 24.5964,
  width: 954.858,
  height: 907.002,
  fill: "#39FF14"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M694.385 501.49L695.369 543.985C695.369 695.725 617.346 790.161 464.748 790.161C464.748 790.161 251.038 790.364 265.073 551.312L265.935 499.658L300.974 305.136L650.618 300.74L694.385 501.49Z",
  fill: "#F4A995"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M654.532 477.961L695.349 482.846C695.349 482.846 709.118 661.128 637.32 723.649L654.532 477.961Z",
  fill: "#D17559"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 659.775,
  y: 359.007,
  width: 35.5943,
  height: 124.41,
  fill: "#D17559"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 265.321,
  y: 359.007,
  width: 35.5943,
  height: 146.634,
  fill: "#F4A995"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M497.188 790.161C421.957 790.161 399.819 711.025 399.819 636.301V247.988L662.421 326.139L665.372 643.139C668.323 719.825 590.624 780.392 497.188 790.161Z",
  fill: "#E28A6F"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M338.839 268.502H604.392V663.654C604.392 680.523 601.047 697.228 594.548 712.813C588.048 728.399 578.521 742.56 566.511 754.489C554.502 766.418 540.244 775.88 524.552 782.336C508.861 788.792 492.043 792.114 475.058 792.114C457.17 792.114 439.456 788.615 422.93 781.815C406.403 775.016 391.386 765.05 378.737 752.486C366.088 739.922 356.054 725.007 349.208 708.592C342.363 692.177 338.839 674.583 338.839 656.815V268.502Z",
  fill: "#ED9677"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M695.368 454.003C723.274 454.003 738.889 475.008 738.889 502.726C738.889 530.443 723.274 550.715 695.368 550.715",
  fill: "#ED9677"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M638.57 496.971C638.588 504.343 637.142 511.646 634.314 518.462C631.487 525.279 627.333 531.474 622.091 536.693C616.849 541.912 610.622 546.053 603.767 548.879C596.911 551.704 589.562 553.158 582.14 553.158C574.718 553.158 567.368 551.704 560.513 548.879C553.657 546.053 547.43 541.912 542.188 536.693C536.947 531.474 532.793 525.279 529.965 518.462C527.138 511.646 525.692 504.343 525.71 496.971C525.71 491.694 530.653 477.58 527.817 481.746C527.677 481.951 636.849 483.172 636.905 483.403C638.003 487.843 638.562 492.398 638.57 496.971Z",
  fill: "#D17559"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M615.283 452.633C624.57 459.523 631.457 469.123 634.98 480.093C638.503 491.062 638.485 502.85 634.929 513.809C631.373 524.767 624.457 534.348 615.149 541.209C605.841 548.071 594.605 551.871 583.015 552.077C571.425 552.284 560.06 548.886 550.51 542.36C540.96 535.834 533.703 526.506 529.754 515.681C525.805 504.856 525.362 493.076 528.487 481.988C531.611 470.901 538.148 461.061 547.181 453.845",
  fill: "#D17559"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M638.474 496.734C638.493 503.997 637.042 511.192 634.206 517.907C631.369 524.623 627.203 530.726 621.944 535.868C616.686 541.01 610.44 545.09 603.563 547.873C596.686 550.657 589.313 552.09 581.868 552.09C574.423 552.09 567.05 550.657 560.173 547.873C553.296 545.09 547.05 541.01 541.792 535.868C536.534 530.726 532.367 524.623 529.53 517.907C526.694 511.192 525.243 503.997 525.262 496.734C525.262 491.535 530.22 477.631 527.375 481.735C527.235 481.937 636.748 483.14 636.804 483.367C637.906 487.742 638.467 492.229 638.474 496.734Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M560.653 478.988C561.178 478.977 561.617 479.165 561.948 479.424C562.127 479.428 562.321 479.433 562.529 479.437C563.885 479.464 565.83 479.498 568.169 479.536C572.846 479.611 579.089 479.702 585.336 479.793C591.583 479.885 597.834 479.978 602.526 480.054C604.871 480.093 606.829 480.127 608.203 480.156C608.889 480.17 609.436 480.183 609.813 480.194C609.999 480.199 610.155 480.206 610.27 480.211C610.323 480.214 610.389 480.217 610.451 480.222C610.476 480.224 610.541 480.231 610.618 480.243C610.646 480.247 610.751 480.263 610.879 480.3C610.954 480.324 611.151 480.402 611.272 480.462C611.498 480.606 612.058 481.24 612.269 481.788H612.271C612.271 481.789 612.271 481.79 612.271 481.792C612.271 481.793 612.272 481.793 612.273 481.794H612.272C612.805 484.202 613.078 486.67 613.081 489.146L613.074 489.896C612.999 493.642 612.3 497.347 611.007 500.824C609.627 504.532 607.596 507.916 605.021 510.775C602.445 513.635 599.374 515.916 595.978 517.477C592.581 519.038 588.931 519.845 585.239 519.845C581.546 519.845 577.896 519.038 574.499 517.477C571.103 515.916 568.033 513.635 565.457 510.775C562.882 507.916 560.851 504.532 559.471 500.824C558.091 497.115 557.388 493.147 557.397 489.146C557.397 488.268 557.573 487.151 557.765 486.13C557.963 485.075 558.214 483.948 558.411 483.033C558.512 482.564 558.592 482.18 558.651 481.878C558.534 481.356 558.505 480.764 558.655 480.333L558.83 480.062C558.897 479.967 558.97 479.868 559.051 479.775C559.13 479.684 559.266 479.537 559.457 479.397C559.616 479.281 560.038 479 560.653 478.988Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 4
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M265.321 453.488C237.415 453.488 221.8 474.492 221.8 502.21C221.8 529.928 237.415 550.2 265.321 550.2",
  fill: "#ED9677"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M472.6 551.799L467.682 587.944C467.682 587.944 417.522 609.435 466.699 629.95",
  fill: "#ED9677"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M421.456 682.704H516.858C516.858 682.704 530.812 683.864 546.057 668.722",
  fill: "#ED9677"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M538.495 646.559C538.495 646.559 574.886 653.397 566.034 677.819L538.495 646.559Z",
  fill: "#ED9677"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M369.083 528.11C381.576 528.11 391.704 518.05 391.704 505.641C391.704 493.233 381.576 483.173 369.083 483.173C356.589 483.173 346.462 493.233 346.462 505.641C346.462 518.05 356.589 528.11 369.083 528.11Z",
  fill: "#D17559"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M406.036 455.32C415.324 462.21 422.211 471.81 425.734 482.78C429.256 493.749 429.238 505.537 425.683 516.496C422.127 527.454 415.211 537.035 405.903 543.896C396.594 550.758 385.359 554.558 373.769 554.764C362.179 554.971 350.814 551.573 341.264 545.047C331.714 538.521 324.457 529.193 320.508 518.368C316.559 507.543 316.116 495.763 319.241 484.675C322.365 473.588 328.901 463.748 337.934 456.532",
  fill: "#D17559"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M429.078 500.324C429.042 514.794 423.08 528.66 412.501 538.879C401.923 549.098 387.591 554.837 372.648 554.837C357.706 554.837 343.374 549.098 332.796 538.879C322.217 528.66 316.255 514.794 316.219 500.324C316.219 495.179 321.162 481.418 318.325 485.48C318.185 485.68 427.357 486.871 427.413 487.095C428.512 491.425 429.071 495.866 429.078 500.324Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M344.496 481.745C345.021 481.734 345.46 481.921 345.792 482.181C345.97 482.185 346.164 482.19 346.372 482.194C347.729 482.221 349.674 482.255 352.012 482.292C356.689 482.367 362.932 482.458 369.179 482.55C375.426 482.642 381.677 482.734 386.369 482.811C388.714 482.849 390.673 482.884 392.047 482.913C392.733 482.927 393.279 482.939 393.656 482.951C393.843 482.956 393.999 482.963 394.113 482.968C394.166 482.971 394.232 482.974 394.294 482.979C394.318 482.981 394.384 482.987 394.462 483C394.49 483.004 394.595 483.02 394.722 483.057C394.797 483.081 394.995 483.159 395.115 483.219C395.342 483.363 395.902 483.997 396.112 484.544H396.114C396.114 484.546 396.114 484.547 396.114 484.548C396.114 484.549 396.116 484.55 396.116 484.551H396.115C396.649 486.959 396.921 489.426 396.925 491.903L396.918 492.653C396.843 496.399 396.144 500.104 394.85 503.581C393.471 507.289 391.439 510.672 388.864 513.532C386.289 516.392 383.217 518.673 379.821 520.234C376.424 521.795 372.774 522.602 369.082 522.602C365.39 522.602 361.739 521.795 358.343 520.234C354.946 518.673 351.876 516.391 349.301 513.532C346.725 510.672 344.694 507.289 343.314 503.581C341.935 499.872 341.231 495.904 341.24 491.903C341.241 491.025 341.416 489.908 341.608 488.887C341.806 487.832 342.057 486.705 342.255 485.79C342.356 485.321 342.436 484.936 342.494 484.635C342.377 484.113 342.348 483.521 342.498 483.089L342.674 482.819C342.74 482.723 342.814 482.625 342.894 482.532C342.973 482.441 343.11 482.293 343.301 482.154C343.459 482.038 343.881 481.757 344.496 481.745Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 4
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M693.873 358.929L695.369 543.987C695.369 695.727 617.346 790.163 464.748 790.163C464.748 790.163 251.038 790.366 265.073 551.314V358.929",
  stroke: "black",
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M695.369 454.007C723.275 454.007 738.89 475.011 738.89 502.729C738.89 530.447 723.275 550.719 695.369 550.719",
  stroke: "black",
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M265.321 453.49C237.415 453.49 221.8 474.494 221.8 502.212C221.8 529.93 237.415 550.201 265.321 550.201",
  stroke: "black",
  strokeMiterlimit: 10
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M318.906 485.921H425.39",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M406.037 455.323C415.324 462.213 422.211 471.814 425.734 482.783C429.257 493.752 429.239 505.541 425.683 516.499C422.127 527.458 415.211 537.038 405.903 543.9C396.594 550.762 385.359 554.561 373.769 554.768C362.179 554.974 350.814 551.577 341.264 545.051C331.714 538.525 324.457 529.197 320.508 518.372C316.559 507.547 316.116 495.766 319.241 484.679C322.365 473.591 328.901 463.752 337.935 456.536",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M528.152 483.234L635.374 483.42",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M615.283 452.636C624.57 459.526 631.457 469.127 634.98 480.096C638.502 491.065 638.485 502.854 634.929 513.812C631.373 524.771 624.457 534.351 615.149 541.213C605.84 548.075 594.605 551.874 583.015 552.081C571.425 552.287 560.06 548.89 550.51 542.364C540.96 535.838 533.703 526.51 529.754 515.685C525.805 504.86 525.362 493.079 528.487 481.992C531.611 470.904 538.147 461.065 547.18 453.849",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M472.6 551.801L467.682 587.946C467.682 587.946 417.522 609.437 466.699 629.952",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M421.457 682.704H516.859C516.859 682.704 530.813 683.864 546.057 668.723",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M538.497 646.56C538.497 646.56 574.887 653.398 566.035 677.821",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M534.081 474.533H627.223V482.189H528.339L534.081 474.533Z",
  fill: "#D17559"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M402.021 484.741H319.724L326.741 474.533H402.021V484.741Z",
  fill: "#D17559"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M502.839 173.583C502.839 165.662 492.94 165.662 480.728 165.662C468.517 165.662 458.613 165.662 458.613 173.583C458.613 181.504 468.517 181.504 480.728 181.504C492.94 181.504 502.839 181.504 502.839 173.583ZM645.172 238.217C615.302 207.979 555.809 181.504 480.728 181.504C405.643 181.504 346.15 207.979 316.276 238.217C263.273 291.857 256.887 427.082 258.944 453.89C262.945 456.804 268.405 458.774 275.239 460.051H275.143C275.143 464.123 392.221 457.819 392.221 457.819C396.204 457.819 412.44 453.89 518.841 453.89C582.073 456.16 608.626 463.791 635.784 460.051C635.784 460.051 686.305 464.455 686.305 460.051L693.263 457.819C700.097 456.542 698.507 456.804 702.503 453.89C704.561 427.082 698.174 291.857 645.172 238.217Z",
  fill: "#0F0F0F"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M562.944 412.274C562.944 412.274 527.189 408.938 478.293 408.938C431.303 408.938 396.606 412.273 396.606 412.273C403.233 388.949 414.129 391.587 417.127 389.973C430.73 388.128 423.785 379.136 480.993 379.136C518.115 383.287 518.806 381.673 537.021 386.976C543.512 386.976 565.38 394.815 562.944 412.274Z",
  fill: "#ED9677"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M668.841 461.82C668.668 455.682 668.673 448.61 668.677 440.424C668.704 390.382 668.755 306.636 625.834 240.274C590.376 185.466 498.737 182.689 480.727 182.689V180.322C498.951 180.322 591.703 183.15 627.818 238.988C671.122 305.939 671.076 390.122 671.049 440.424C671.04 448.592 671.035 455.651 671.209 461.752L668.841 461.82Z",
  fill: "#C58FFF"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M292.609 461.82L290.237 461.752C290.415 455.651 290.41 448.592 290.406 440.424C290.374 390.122 290.324 305.939 333.628 238.988C369.747 183.15 462.5 180.322 480.723 180.322V182.689C462.714 182.689 371.07 185.466 335.621 240.274C292.696 306.636 292.746 390.382 292.773 440.424C292.778 448.61 292.782 455.682 292.609 461.82Z",
  fill: "#C58FFF"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M701.522 445.532L700.5 444.328C701.17 443.763 701.736 443.152 702.183 442.523L703.474 443.439C702.945 444.173 702.292 444.88 701.522 445.532ZM575.998 449.057C573.817 448.925 571.71 448.815 569.694 448.72L569.767 447.142C571.792 447.233 573.899 447.347 576.089 447.475L575.998 449.057ZM585.454 449.659C583.301 449.513 581.194 449.372 579.15 449.239L579.25 447.666C581.299 447.799 583.406 447.94 585.564 448.086L585.454 449.659ZM692.813 449.878L692.353 448.364C694.551 447.685 696.463 446.896 698.023 446.025L698.794 447.402C697.133 448.327 695.126 449.162 692.813 449.878ZM594.915 450.325L588.606 449.878L588.716 448.3L595.025 448.752L594.915 450.325ZM604.376 451.009L598.067 450.553L598.181 448.98L604.49 449.436L604.376 451.009ZM613.832 451.679L607.524 451.241L607.638 449.668L613.947 450.106L613.832 451.679ZM683.439 451.916L683.206 450.357C685.414 450.024 687.485 449.627 689.346 449.18L689.716 450.717C687.809 451.173 685.697 451.579 683.439 451.916ZM623.302 452.29C621.195 452.158 619.087 452.021 616.989 451.889L617.094 450.316C619.188 450.448 621.291 450.58 623.398 450.708L623.302 452.29ZM632.786 452.805C630.683 452.71 628.571 452.591 626.464 452.473L626.555 450.895C628.658 451.009 630.765 451.127 632.859 451.228L632.786 452.805ZM673.96 452.942L673.841 451.369C676.04 451.2 678.143 451.004 680.1 450.776L680.287 452.345C678.307 452.577 676.177 452.774 673.96 452.942ZM642.279 453.216C640.185 453.138 638.073 453.052 635.952 452.961L636.025 451.383C638.142 451.474 640.249 451.561 642.334 451.634L642.279 453.216ZM664.453 453.398L664.412 451.821C666.565 451.766 668.664 451.684 670.707 451.565L670.794 453.147C668.737 453.261 666.62 453.344 664.453 453.398ZM651.776 453.448C649.687 453.426 647.575 453.376 645.44 453.312L645.486 451.734C647.612 451.793 649.714 451.843 651.795 451.871L651.776 453.448ZM656.977 453.49L654.951 453.485V451.907L656.977 451.912C658.423 451.912 659.851 451.898 661.26 451.88L661.278 453.462C659.864 453.48 658.427 453.49 656.977 453.49Z",
  fill: "#C58FFF"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M484.518 453.87C529.875 453.87 569.233 456.172 600.855 458.024C623.239 459.328 642.571 460.459 658.272 460.459C680.196 460.459 693.434 458.165 700.983 453.035C703.164 420.891 694.679 290.564 644.049 239.332C617.185 212.14 560.174 183.088 480.728 183.088C401.277 183.088 344.265 212.14 317.401 239.332C266.771 290.564 258.287 420.891 260.463 453.035C268.017 458.165 281.255 460.459 303.173 460.459C318.879 460.459 338.207 459.328 360.591 458.024C392.213 456.172 431.566 453.87 476.928 453.87L480.728 453.874L484.518 453.87ZM658.272 463.619C642.48 463.619 623.107 462.484 600.672 461.175C569.087 459.328 529.784 457.03 484.518 457.03L480.728 457.034L476.928 457.03C431.658 457.03 392.354 459.328 360.774 461.175C338.344 462.484 318.971 463.619 303.173 463.619C279.644 463.619 266.137 461.093 258.013 455.169L257.425 454.745L257.37 454.015C254.979 422.884 263.364 289.52 315.148 237.111C342.463 209.463 400.305 179.928 480.728 179.928C561.145 179.928 618.983 209.463 646.298 237.111C698.082 289.52 706.467 422.884 704.081 454.015L704.022 454.745L703.438 455.169C695.309 461.093 681.802 463.619 658.272 463.619Z",
  fill: "#C58FFF"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M571.632 457.877L568.471 457.874C568.489 448.044 563.134 407.419 560.205 402.04C557.149 396.421 535.983 380.379 480.727 380.379C425.462 380.379 404.296 396.421 401.24 402.04C398.316 407.419 392.956 448.044 392.974 457.874L389.813 457.877C389.795 448.589 395.009 407.368 398.243 401.423C401.723 395.028 423.323 378.434 480.727 378.434C538.127 378.434 559.721 395.028 563.207 401.423C566.436 407.368 571.65 448.589 571.632 457.877Z",
  fill: "#C58FFF"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M484.071 369.461C481.954 369.425 479.91 369.423 477.789 369.455L477.753 368.433C479.892 368.401 481.963 368.407 484.116 368.442L484.071 369.461ZM468.374 369.802L468.232 368.787C470.363 368.666 472.498 368.569 474.573 368.507L474.651 369.526C472.593 369.587 470.481 369.679 468.374 369.802ZM493.495 369.829C491.378 369.705 489.262 369.605 487.218 369.537L487.296 368.522C489.367 368.589 491.502 368.687 493.641 368.813L493.495 369.829ZM459.004 370.541L458.762 369.534C460.879 369.325 462.982 369.146 465.067 368.996L465.245 370.011C463.183 370.159 461.098 370.335 459.004 370.541ZM502.86 370.585C500.766 370.373 498.682 370.191 496.62 370.038L496.798 369.028C498.887 369.181 500.99 369.364 503.097 369.576L502.86 370.585ZM449.721 371.648L449.388 370.653C451.464 370.362 453.548 370.1 455.624 369.867L455.898 370.871C453.84 371.101 451.778 371.363 449.721 371.648ZM512.129 371.704C510.077 371.416 508.015 371.151 505.957 370.915L506.236 369.911C508.311 370.15 510.391 370.415 512.467 370.706L512.129 371.704ZM440.561 373.123L440.128 372.14C442.14 371.775 444.206 371.424 446.282 371.107L446.647 372.099C444.594 372.414 442.55 372.758 440.561 373.123ZM521.276 373.194C519.287 372.826 517.238 372.475 515.195 372.157L515.564 371.165C517.631 371.489 519.702 371.84 521.713 372.213L521.276 373.194ZM431.593 374.987L431.05 374.03C432.998 373.574 435.028 373.135 437.085 372.723L437.551 373.7C435.521 374.103 433.514 374.536 431.593 374.987ZM530.253 375.081C528.332 374.625 526.33 374.186 524.3 373.78L524.77 372.805C526.823 373.217 528.852 373.665 530.796 374.121L530.253 375.081ZM422.876 377.286L422.214 376.361C424.103 375.799 426.073 375.26 428.076 374.754L428.651 375.702C426.68 376.2 424.732 376.735 422.876 377.286ZM538.952 377.401C537.1 376.847 535.161 376.308 533.186 375.802L533.765 374.854C535.768 375.369 537.739 375.914 539.618 376.476L538.952 377.401ZM414.532 380.083L413.73 379.205C415.518 378.528 417.402 377.869 419.336 377.248L420.043 378.16C418.141 378.77 416.289 379.417 414.532 380.083ZM547.282 380.221C545.525 379.55 543.673 378.896 541.78 378.281L542.492 377.371C544.417 377.998 546.301 378.664 548.089 379.344L547.282 380.221ZM406.755 383.465L405.788 382.662C407.421 381.84 409.177 381.045 411.006 380.283L411.864 381.139C410.067 381.884 408.351 382.664 406.755 383.465ZM555.023 383.633C553.445 382.829 551.729 382.04 549.932 381.287L550.799 380.436C552.633 381.204 554.38 382.008 555.999 382.829L555.023 383.633ZM399.871 387.534L398.703 386.845C400.099 385.862 401.646 384.893 403.311 383.969L404.342 384.74C402.727 385.641 401.222 386.58 399.871 387.534ZM561.856 387.728C560.52 386.768 559.028 385.823 557.418 384.917L558.462 384.148C560.114 385.084 561.651 386.059 563.029 387.048L561.856 387.728ZM394.37 392.353L392.997 391.847C394.032 390.681 395.25 389.524 396.619 388.417L397.85 389.056C396.532 390.119 395.364 391.228 394.37 392.353ZM567.28 392.586C566.304 391.458 565.15 390.339 563.845 389.268L565.095 388.638C566.445 389.751 567.645 390.916 568.662 392.091L567.28 392.586ZM390.88 397.864L389.347 397.608C389.877 396.28 390.607 394.967 391.519 393.695L392.951 394.122C392.08 395.338 391.386 396.595 390.88 397.864ZM570.66 398.12C570.181 396.845 569.511 395.583 568.662 394.367L570.104 393.946C570.989 395.226 571.696 396.548 572.198 397.879L570.66 398.12ZM389.17 403.829L387.609 403.667C387.952 402.324 388.312 400.979 388.691 399.639L390.246 399.822C389.867 401.158 389.512 402.495 389.17 403.829ZM572.343 404.105C572.006 402.766 571.65 401.426 571.276 400.09L572.832 399.91C573.206 401.253 573.561 402.595 573.904 403.937L572.343 404.105ZM387.737 409.864L386.173 409.722C386.469 408.374 386.784 407.029 387.108 405.68L388.672 405.836C388.344 407.185 388.034 408.527 387.737 409.864ZM573.771 410.14C573.479 408.801 573.169 407.458 572.845 406.116L574.405 405.957C574.729 407.308 575.039 408.654 575.331 409.996L573.771 410.14ZM386.496 415.919L384.927 415.796C385.183 414.45 385.452 413.099 385.739 411.745L387.304 411.88C387.021 413.229 386.752 414.577 386.496 415.919ZM575.003 416.205C574.748 414.86 574.483 413.514 574.2 412.163L575.769 412.027C576.048 413.382 576.317 414.733 576.572 416.081L575.003 416.205ZM385.42 421.987L383.851 421.878C384.074 420.533 384.307 419.178 384.553 417.818L386.122 417.939C385.876 419.293 385.643 420.644 385.42 421.987ZM576.07 422.281C575.851 420.936 575.619 419.585 575.377 418.23L576.942 418.113C577.188 419.47 577.421 420.824 577.644 422.172L576.07 422.281ZM384.48 428.066L382.906 427.969C383.102 426.624 383.308 425.269 383.522 423.906L385.091 424.009C384.877 425.366 384.676 426.724 384.48 428.066ZM577.015 428.366C576.819 427.024 576.613 425.67 576.399 424.313L577.973 424.209C578.187 425.573 578.392 426.924 578.588 428.272L577.015 428.366ZM383.641 434.16L382.067 434.072C382.245 432.726 382.427 431.372 382.614 430.003L384.188 430.094C384.001 431.458 383.819 432.812 383.641 434.16ZM577.84 434.457C577.667 433.112 577.484 431.758 577.297 430.395L578.871 430.303C579.058 431.669 579.241 433.024 579.414 434.369L577.84 434.457ZM382.879 440.251L381.305 440.172C381.469 438.829 381.634 437.469 381.807 436.103L383.381 436.186C383.207 437.554 383.043 438.909 382.879 440.251ZM578.602 440.557C578.443 439.209 578.278 437.855 578.105 436.489L579.679 436.406C579.852 437.775 580.016 439.129 580.181 440.478L578.602 440.557ZM382.158 446.351L380.58 446.277L381.059 442.209L382.637 442.285L382.158 446.351ZM579.327 446.651L578.849 442.589L580.422 442.509L580.901 446.575L579.327 446.651ZM381.437 452.454L379.864 452.374L380.343 448.309L381.921 448.385L381.437 452.454ZM580.048 452.757C579.884 451.42 579.724 450.066 579.565 448.686L581.139 448.612C581.298 449.984 581.458 451.338 581.622 452.678L580.048 452.757ZM580.778 458.557C580.614 457.323 580.454 456.069 580.295 454.794L581.868 454.715C582.028 455.984 582.188 457.238 582.352 458.471L580.778 458.557ZM380.671 458.557L379.097 458.471C379.275 457.141 379.444 455.786 379.617 454.406L381.191 454.491C381.018 455.869 380.849 457.223 380.671 458.557Z",
  fill: "#C58FFF"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M259.923 445.532C259.157 444.88 258.505 444.173 257.976 443.439L259.262 442.523C259.714 443.152 260.279 443.763 260.95 444.328L259.923 445.532ZM385.452 449.057L385.356 447.475C387.545 447.347 389.657 447.233 391.683 447.142L391.751 448.72C389.74 448.815 387.632 448.925 385.452 449.057ZM375.991 449.659L375.886 448.086C378.043 447.94 380.151 447.799 382.199 447.666L382.299 449.239C380.251 449.372 378.148 449.513 375.991 449.659ZM268.632 449.878C266.323 449.162 264.307 448.332 262.651 447.402L263.422 446.025C264.987 446.896 266.894 447.685 269.097 448.364L268.632 449.878ZM366.534 450.325L366.42 448.752L372.729 448.3L372.839 449.878L366.534 450.325ZM357.069 451.009L356.955 449.436L363.264 448.98L363.378 450.553L357.069 451.009ZM347.612 451.679L347.503 450.106L353.807 449.668L353.917 451.241L347.612 451.679ZM278.006 451.916C275.752 451.579 273.64 451.173 271.729 450.717L272.099 449.18C273.964 449.627 276.031 450.024 278.239 450.357L278.006 451.916ZM338.147 452.281L338.051 450.703C340.154 450.58 342.257 450.448 344.355 450.307L344.46 451.88C342.357 452.021 340.254 452.158 338.147 452.281ZM328.663 452.805L328.586 451.228C330.68 451.127 332.787 451.009 334.894 450.895L334.986 452.473C332.874 452.591 330.762 452.71 328.663 452.805ZM287.485 452.942C285.268 452.783 283.142 452.577 281.158 452.345L281.345 450.776C283.302 451.004 285.409 451.2 287.604 451.369L287.485 452.942ZM319.166 453.216L319.116 451.634C321.2 451.561 323.308 451.474 325.424 451.383L325.493 452.961C323.372 453.052 321.26 453.138 319.166 453.216ZM296.996 453.398C294.825 453.344 292.708 453.261 290.655 453.147L290.742 451.565C292.781 451.684 294.884 451.766 297.037 451.821L296.996 453.398ZM309.668 453.448L309.646 451.871C311.726 451.843 313.833 451.793 315.959 451.734L316.005 453.312C313.87 453.376 311.753 453.426 309.668 453.448ZM304.473 453.49C303.018 453.49 301.585 453.48 300.167 453.462L300.189 451.88C301.599 451.898 303.027 451.912 304.473 451.912L306.484 451.907L306.498 452.696L306.493 453.485L304.473 453.49Z",
  fill: "#C58FFF"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M482.211 368.412H479.239V181.503H482.211V368.412Z",
  fill: "#C58FFF"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M475.211 189.53H473.225V181.577H475.211V189.53ZM475.211 201.454H473.225V193.501H475.211V201.454ZM475.211 213.378H473.225V205.43H475.211V213.378ZM475.211 225.302H473.225V217.354H475.211V225.302ZM475.211 237.231H473.225V229.278H475.211V237.231ZM475.211 249.155H473.225V241.202H475.211V249.155ZM475.211 261.085H473.225V253.132H475.211V261.085ZM475.211 273.009H473.225V265.056H475.211V273.009ZM475.211 284.933H473.225V276.986H475.211V284.933ZM475.211 296.857H473.225V288.91H475.211V296.857ZM475.211 308.787H473.225V300.833H475.211V308.787ZM475.211 320.71H473.225V312.757H475.211V320.71ZM475.211 332.634H473.225V324.687H475.211V332.634ZM475.211 344.564H473.225V336.611H475.211V344.564ZM475.211 356.488H473.225V348.541H475.211V356.488ZM475.211 368.412H473.225V360.465H475.211V368.412Z",
  fill: "#C58FFF"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M488.473 189.53H486.481V181.577H488.473V189.53ZM488.473 201.454H486.481V193.501H488.473V201.454ZM488.473 213.378H486.481V205.43H488.473V213.378ZM488.473 225.302H486.481V217.354H488.473V225.302ZM488.473 237.231H486.481V229.278H488.473V237.231ZM488.473 249.155H486.481V241.202H488.473V249.155ZM488.473 261.085H486.481V253.132H488.473V261.085ZM488.473 273.009H486.481V265.056H488.473V273.009ZM488.473 284.933H486.481V276.986H488.473V284.933ZM488.473 296.857H486.481V288.91H488.473V296.857ZM488.473 308.787H486.481V300.833H488.473V308.787ZM488.473 320.71H486.481V312.757H488.473V320.71ZM488.473 332.634H486.481V324.687H488.473V332.634ZM488.473 344.564H486.481V336.611H488.473V344.564ZM488.473 356.488H486.481V348.541H488.473V356.488ZM488.473 368.412H486.481V360.465H488.473V368.412Z",
  fill: "#C58FFF"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M480.727 167.24C467.996 167.24 460.191 167.55 460.191 173.583C460.191 179.616 467.996 179.927 480.727 179.927C493.459 179.927 501.259 179.616 501.259 173.583C501.259 167.55 493.459 167.24 480.727 167.24ZM480.727 183.087C468.009 183.087 457.029 183.087 457.029 173.583C457.029 164.08 468.009 164.08 480.727 164.08C493.441 164.08 504.421 164.08 504.421 173.583C504.421 183.087 493.441 183.087 480.727 183.087Z",
  fill: "#C58FFF"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M522.968 457.452L521.918 454.474C530.841 451.337 536.872 443.284 537.269 433.963C537.684 424.359 532.191 416.051 522.589 411.723L523.885 408.846C534.714 413.721 540.895 423.16 540.425 434.1C539.974 444.725 533.117 453.886 522.968 457.452Z",
  fill: "#C58FFF"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M413.201 429.421C410.227 429.421 407.805 431.838 407.805 434.816C407.805 437.789 410.227 440.215 413.201 440.215C416.18 440.215 418.597 437.789 418.597 434.816C418.597 431.838 416.18 429.421 413.201 429.421ZM413.201 443.37C408.484 443.37 404.643 439.535 404.643 434.816C404.643 430.101 408.484 426.261 413.201 426.261C417.922 426.261 421.759 430.101 421.759 434.816C421.759 439.535 417.922 443.37 413.201 443.37Z",
  fill: "#C58FFF"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M444.339 427.726C441.364 427.726 438.942 430.152 438.942 433.125C438.942 436.098 441.364 438.519 444.339 438.519C447.317 438.519 449.735 436.098 449.735 433.125C449.735 430.152 447.317 427.726 444.339 427.726ZM444.339 441.675C439.622 441.675 435.781 437.84 435.781 433.125C435.781 428.405 439.622 424.565 444.339 424.565C449.06 424.565 452.896 428.405 452.896 433.125C452.896 437.84 449.06 441.675 444.339 441.675Z",
  fill: "#C58FFF"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M478.291 426.193C475.313 426.193 472.895 428.614 472.895 431.587C472.895 434.57 475.313 436.986 478.291 436.986C481.266 436.986 483.688 434.57 483.688 431.587C483.688 428.614 481.266 426.193 478.291 426.193ZM478.291 440.146C473.575 440.146 469.734 436.307 469.734 431.587C469.734 426.872 473.575 423.037 478.291 423.037C483.008 423.037 486.849 426.872 486.849 431.587C486.849 436.307 483.008 440.146 478.291 440.146Z",
  fill: "#C58FFF"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M513.698 427.726C510.724 427.726 508.302 430.152 508.302 433.125C508.302 436.098 510.724 438.519 513.698 438.519C516.673 438.519 519.095 436.098 519.095 433.125C519.095 430.152 516.673 427.726 513.698 427.726ZM513.698 441.675C508.982 441.675 505.141 437.84 505.141 433.125C505.141 428.405 508.982 424.565 513.698 424.565C518.42 424.565 522.256 428.405 522.256 433.125C522.256 437.84 518.42 441.675 513.698 441.675Z",
  fill: "#C58FFF"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M567.034 414.875C560.42 413.922 508.878 410.511 480.728 410.511C452.569 410.511 401.026 413.922 394.412 414.875L393.965 411.743C400.629 410.79 452.454 407.351 480.728 407.351C508.992 407.351 560.822 410.79 567.486 411.743L567.034 414.875Z",
  fill: "#C58FFF"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M3.00006 955H958V930H3.00006V955Z",
  fill: "white"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M479.573 952.119L478.294 950.086L477.007 952.119H479.573ZM388.565 947.437H390.651L390.639 947.425H388.577L388.565 947.437ZM244.476 947.553L246.867 951.364H250.911L255.902 943.057L255.909 943.068V943.057L258.785 947.425H388.58L389.614 945.787L387.887 943.057H391.333L389.614 945.787L390.647 947.425H416.199L417.665 949.76L420.56 954.355L422.485 951.294L432.258 951.364H433.825L437.783 945.078H448.298L450.566 948.674L473.787 948.651L475.589 945.787L478.294 950.086L479.196 948.651L530.846 948.674L534.837 955L542.357 943.057L545.189 947.553H546.39L547.046 946.513L546.006 944.857H548.087L547.05 946.513L547.692 947.535L568.932 947.559V927.123H3.04848V947.559H244.476V947.553ZM432.288 946.298H432.829V947.158H432.288V946.298ZM432.288 948.023H432.829V948.883H432.288V948.023ZM428.088 946.298H428.625V948.883H428.088V946.298ZM426.01 948.023H426.551V948.883H426.01V948.023ZM275.773 943.062H277.399V945.647H275.773V943.062ZM270.357 943.062H270.897V945.647H270.357V943.062ZM266.563 943.062H267.104V945.647H266.563V943.062ZM265.742 943.062H266.287V945.647H265.742V943.062Z",
  fill: "#FCEE0A"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M609.687 930.035L608.405 928.002L607.119 930.035H609.683H609.687Z",
  fill: "#FCEE0A"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M734.556 927.58H568.887V933.11L568.846 945.541V947.975L603.79 947.952L605.593 946.25L608.29 949.381L608.293 949.387L609.198 947.952L701.878 947.975L704.618 952.024H708.098L713.385 943.52L716.217 948.016H717.418L718.074 946.976L717.034 945.32H719.114L718.078 946.976L718.719 947.998L728.53 948.022L734.556 927.585V927.58Z",
  fill: "#FCEE0A"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M734.556 927.58H568.887V933.11L568.846 945.541V947.975L603.79 947.952L605.593 946.25L608.29 949.381L608.293 949.387L609.198 947.952L701.878 947.975L704.618 952.024H708.098L713.385 943.52L716.217 948.016H717.418L718.074 946.976L717.034 945.32H719.114L718.078 946.976L718.719 947.998L728.53 948.022L734.556 927.585V927.58Z",
  fill: "#FCEE0A"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M832.623 947.857L838.631 927.433H706.023L700.011 947.857H832.623Z",
  fill: "white"
});

var _ref59 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_823_282)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M731.531 950.662L738.589 926.673L736.345 925.013L729.287 949.002L731.531 950.662Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M735.152 950.5L742.148 926.722L740.033 925.157L733.037 948.936L735.152 950.5Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M738.79 950.357L745.724 926.789L743.742 925.323L736.808 948.891L738.79 950.357Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.453 925.592L749.263 926.783L742.328 950.35L740.522 949.159L747.453 925.592Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746.046 950.051L752.858 926.898L751.141 925.629L744.33 948.781L746.046 950.051Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749.666 949.891L756.416 926.949L754.829 925.776L748.079 948.717L749.666 949.891Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M753.305 949.736L759.99 927.003L758.536 925.928L751.851 948.661L753.305 949.736Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756.922 949.58L763.548 927.059L762.227 926.081L755.601 948.602L756.922 949.58Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.555 949.435L767.121 927.119L765.932 926.24L759.367 948.556L760.555 949.435Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M764.174 949.273L770.68 927.17L769.621 926.387L763.115 948.49L764.174 949.273Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M767.81 949.125L774.251 927.231L773.325 926.546L766.883 948.44L767.81 949.125Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M771.446 948.97L777.825 927.287L777.032 926.7L770.652 948.383L771.446 948.97Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M775.074 948.818L781.391 927.338L780.73 926.849L774.413 948.329L775.074 948.818Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M778.695 948.659L784.952 927.391L784.421 926.998L778.164 948.266L778.695 948.659Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782.329 948.51L788.52 927.449L788.121 927.155L781.931 948.216L782.329 948.51Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M785.946 948.35L792.088 927.51L791.823 927.313L785.681 948.153L785.946 948.35Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795.523 927.463L795.655 927.562L795.625 927.672L789.584 948.201L789.449 948.103L789.482 947.998L795.523 927.463Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M799.219 927.62H799.222L793.211 948.05V948.045L799.219 927.62Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731.531 950.662L738.589 926.673L736.345 925.013L729.287 949.002L731.531 950.662Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M735.152 950.5L742.148 926.722L740.033 925.157L733.037 948.936L735.152 950.5Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M738.79 950.357L745.724 926.789L743.742 925.323L736.808 948.891L738.79 950.357Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.453 925.592L749.263 926.783L742.328 950.35L740.522 949.159L747.453 925.592Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746.046 950.051L752.858 926.898L751.141 925.629L744.33 948.781L746.046 950.051Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749.666 949.891L756.416 926.949L754.829 925.776L748.079 948.717L749.666 949.891Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M753.305 949.736L759.99 927.003L758.536 925.928L751.851 948.661L753.305 949.736Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756.922 949.58L763.548 927.059L762.227 926.081L755.601 948.602L756.922 949.58Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.555 949.435L767.121 927.119L765.932 926.24L759.367 948.556L760.555 949.435Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M764.174 949.273L770.68 927.17L769.621 926.387L763.115 948.49L764.174 949.273Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M767.81 949.125L774.251 927.231L773.325 926.546L766.883 948.44L767.81 949.125Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M771.446 948.97L777.825 927.287L777.032 926.7L770.652 948.383L771.446 948.97Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M775.074 948.818L781.391 927.338L780.73 926.849L774.413 948.329L775.074 948.818Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M778.695 948.659L784.952 927.391L784.421 926.998L778.164 948.266L778.695 948.659Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782.329 948.51L788.52 927.449L788.121 927.155L781.931 948.216L782.329 948.51Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M785.946 948.35L792.088 927.51L791.823 927.313L785.681 948.153L785.946 948.35Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795.523 927.463L795.655 927.562L795.625 927.672L789.584 948.201L789.449 948.103L789.482 947.998L795.523 927.463Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M799.219 927.62H799.222L793.211 948.05V948.045L799.219 927.62Z",
  fill: "#FCEE0A"
}));

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M479.623 952.106L478.343 950.064L477.056 952.106H479.623ZM388.596 947.403H390.682L390.671 947.392H388.608L388.596 947.403ZM244.477 947.52L246.869 951.348H250.913L255.905 943.004L255.913 943.016V943.004L258.789 947.392H388.611L389.645 945.746L387.917 943.004H391.365L389.645 945.746L390.678 947.392H416.236L417.702 949.737L420.598 954.352L422.523 951.278L432.298 951.348H433.865L437.824 945.035H448.342L450.61 948.646L473.836 948.623L475.638 945.746L478.343 950.064L479.246 948.623L530.906 948.646L534.898 955L542.42 943.004L545.252 947.52H546.453L547.11 946.476L546.069 944.813H548.151L547.114 946.476L547.755 947.503L569 947.526V927H3.00001V947.526H244.477V947.52ZM432.328 946.26H432.869V947.123H432.328V946.26ZM432.328 947.993H432.869V948.856H432.328V947.993ZM428.127 946.26H428.664V948.856H428.127V946.26ZM426.049 947.993H426.59V948.856H426.049V947.993ZM275.781 943.01H277.407V945.606H275.781V943.01ZM270.363 943.01H270.904V945.606H270.363V943.01ZM266.569 943.01H267.11V945.606H266.569V943.01ZM265.748 943.01H266.293V945.606H265.748V943.01Z",
  fill: "#39FF14"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M609.687 930.035L608.405 928.002L607.119 930.035H609.683H609.687Z",
  fill: "#FCEE0A"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M734.556 927.58H568.887V933.11L568.846 945.541V947.975L603.79 947.952L605.593 946.25L608.29 949.381L608.293 949.387L609.198 947.952L701.878 947.975L704.618 952.024H708.098L713.385 943.52L716.217 948.016H717.418L718.074 946.976L717.034 945.32H719.114L718.078 946.976L718.719 947.998L728.53 948.022L734.556 927.585V927.58Z",
  fill: "#FCEE0A"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M734.556 927.58H568.887V933.11L568.846 945.541V947.975L603.79 947.952L605.593 946.25L608.29 949.381L608.293 949.387L609.198 947.952L701.878 947.975L704.618 952.024H708.098L713.385 943.52L716.217 948.016H717.418L718.074 946.976L717.034 945.32H719.114L718.078 946.976L718.719 947.998L728.53 948.022L734.556 927.585V927.58Z",
  fill: "#39FF14"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M832.623 947.857L838.631 927.433H706.023L700.011 947.857H832.623Z",
  fill: "white"
});

var _ref65 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_823_282)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M731.531 950.662L738.589 926.673L736.345 925.013L729.287 949.002L731.531 950.662Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M735.152 950.5L742.148 926.722L740.033 925.157L733.037 948.936L735.152 950.5Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M738.79 950.357L745.724 926.789L743.742 925.323L736.808 948.891L738.79 950.357Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.453 925.592L749.263 926.783L742.328 950.35L740.522 949.159L747.453 925.592Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746.046 950.051L752.858 926.898L751.141 925.629L744.33 948.781L746.046 950.051Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749.666 949.891L756.416 926.949L754.829 925.776L748.079 948.717L749.666 949.891Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M753.305 949.736L759.99 927.003L758.536 925.928L751.851 948.661L753.305 949.736Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756.922 949.58L763.548 927.059L762.227 926.081L755.601 948.602L756.922 949.58Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.555 949.435L767.121 927.119L765.932 926.24L759.367 948.556L760.555 949.435Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M764.174 949.273L770.68 927.17L769.621 926.387L763.115 948.49L764.174 949.273Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M767.81 949.125L774.251 927.231L773.325 926.546L766.883 948.44L767.81 949.125Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M771.446 948.97L777.825 927.287L777.032 926.7L770.652 948.383L771.446 948.97Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M775.074 948.818L781.391 927.338L780.73 926.849L774.413 948.329L775.074 948.818Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M778.695 948.659L784.952 927.391L784.421 926.998L778.164 948.266L778.695 948.659Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782.329 948.51L788.52 927.449L788.121 927.155L781.931 948.216L782.329 948.51Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M785.946 948.35L792.088 927.51L791.823 927.313L785.681 948.153L785.946 948.35Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795.523 927.463L795.655 927.562L795.625 927.672L789.584 948.201L789.449 948.103L789.482 947.998L795.523 927.463Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M799.219 927.62H799.222L793.211 948.05V948.045L799.219 927.62Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731.531 950.662L738.589 926.673L736.345 925.013L729.287 949.002L731.531 950.662Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M735.152 950.5L742.148 926.722L740.033 925.157L733.037 948.936L735.152 950.5Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M738.79 950.357L745.724 926.789L743.742 925.323L736.808 948.891L738.79 950.357Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.453 925.592L749.263 926.783L742.328 950.35L740.522 949.159L747.453 925.592Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746.046 950.051L752.858 926.898L751.141 925.629L744.33 948.781L746.046 950.051Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749.666 949.891L756.416 926.949L754.829 925.776L748.079 948.717L749.666 949.891Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M753.305 949.736L759.99 927.003L758.536 925.928L751.851 948.661L753.305 949.736Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756.922 949.58L763.548 927.059L762.227 926.081L755.601 948.602L756.922 949.58Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.555 949.435L767.121 927.119L765.932 926.24L759.367 948.556L760.555 949.435Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M764.174 949.273L770.68 927.17L769.621 926.387L763.115 948.49L764.174 949.273Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M767.81 949.125L774.251 927.231L773.325 926.546L766.883 948.44L767.81 949.125Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M771.446 948.97L777.825 927.287L777.032 926.7L770.652 948.383L771.446 948.97Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M775.074 948.818L781.391 927.338L780.73 926.849L774.413 948.329L775.074 948.818Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M778.695 948.659L784.952 927.391L784.421 926.998L778.164 948.266L778.695 948.659Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782.329 948.51L788.52 927.449L788.121 927.155L781.931 948.216L782.329 948.51Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M785.946 948.35L792.088 927.51L791.823 927.313L785.681 948.153L785.946 948.35Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795.523 927.463L795.655 927.562L795.625 927.672L789.584 948.201L789.449 948.103L789.482 947.998L795.523 927.463Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M799.219 927.62H799.222L793.211 948.05V948.045L799.219 927.62Z",
  fill: "#39FF14"
}));

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M958 0H0V25H958V0Z",
  fill: "white"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M479.93 2.88127L481.213 4.91442L482.504 2.88127H479.93ZM571.223 7.56333H569.132L569.143 7.57494H571.212L571.223 7.56333ZM715.766 7.44714L713.367 3.63644H709.311L704.304 11.9433L704.296 11.9317V11.9433L701.411 7.57494H571.208L570.172 9.21309L571.904 11.9433H568.447L570.172 9.21309L569.135 7.57494H543.503L542.032 5.23973L539.128 0.644798L537.197 3.70615L527.393 3.63644H525.822L521.851 9.92179H511.303L509.028 6.32601L485.734 6.34923L483.926 9.21309L481.213 4.91442L480.308 6.34923L428.496 6.32601L424.492 0L416.948 11.9433L414.108 7.44714H412.903L412.245 8.48696L413.289 10.1426H411.201L412.241 8.48696L411.597 7.46458L390.29 7.44137V27.8774H957.951V7.44137H715.766V7.44714ZM527.363 8.7019H526.821V7.84214H527.363V8.7019ZM527.363 6.97661H526.821V6.1169H527.363V6.97661ZM531.577 8.7019H531.038V6.1169H531.577V8.7019ZM533.661 6.97661H533.119V6.1169H533.661V6.97661ZM684.37 11.9375H682.739V9.3525H684.37V11.9375ZM689.804 11.9375H689.261V9.3525H689.804V11.9375ZM693.609 11.9375H693.067V9.3525H693.609V11.9375ZM694.432 11.9375H693.886V9.3525H694.432V11.9375Z",
  fill: "#FCEE0A"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M349.407 24.9651L350.693 26.9982L351.984 24.9651H349.411H349.407Z",
  fill: "#FCEE0A"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M224.146 27.4204H390.335V21.8902L390.377 9.45893V7.02494L355.322 7.04822L353.514 8.75024L350.809 5.61918L350.805 5.61337L349.898 7.04822L256.927 7.02494L254.178 2.97607H250.687L245.384 11.4805L242.543 6.98429H241.338L240.68 8.02411L241.723 9.67965H239.636L240.676 8.02411L240.033 7.00173L230.191 6.97846L224.146 27.4146V27.4204Z",
  fill: "#FCEE0A"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M224.146 27.4204H390.335V21.8902L390.377 9.45893V7.02494L355.322 7.04822L353.514 8.75024L350.809 5.61918L350.805 5.61337L349.898 7.04822L256.927 7.02494L254.178 2.97607H250.687L245.384 11.4805L242.543 6.98429H241.338L240.68 8.02411L241.723 9.67965H239.636L240.676 8.02411L240.033 7.00173L230.191 6.97846L224.146 27.4146V27.4204Z",
  fill: "#FCEE0A"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M125.771 7.14282L119.744 27.5673H252.769L258.8 7.14282H125.771Z",
  fill: "white"
});

var _ref72 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask4_823_282)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M227.18 4.33765L220.1 28.3271L222.351 29.9874L229.431 5.99785L227.18 4.33765Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.548 4.49951L216.53 28.2784L218.652 29.8429L225.67 6.06392L223.548 4.49951Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.899 4.64258L212.943 28.2109L214.931 29.6771L221.887 6.10874L219.899 4.64258Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.208 29.4081L209.392 28.2173L216.349 4.65015L218.161 5.84099L211.208 29.4081Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.62 4.94922L205.787 28.1017L207.509 29.3714L214.342 6.21894L212.62 4.94922Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.988 5.10864L202.217 28.0506L203.81 29.2245L210.581 6.28258L208.988 5.10864Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.338 5.26392L198.632 27.9971L200.091 29.0724L206.797 6.33921L205.338 5.26392Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.709 5.42041L195.062 27.9412L196.388 28.9186L203.035 6.39784L201.709 5.42041Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.065 5.56519L191.479 27.8806L192.671 28.7598L199.257 6.44443L198.065 5.56519Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.434 5.72656L187.908 27.8296L188.97 28.6134L195.497 6.51031L194.434 5.72656Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.788 5.87476L184.326 27.769L185.255 28.4543L191.717 6.55994L190.788 5.87476Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.14 6.02954L180.741 27.7133L181.537 28.3003L187.936 6.61651L187.14 6.02954Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.5 6.18213L177.164 27.6623L177.827 28.1508L184.163 6.67064L183.5 6.18213Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.869 6.34082L173.591 27.6087L174.124 28.0017L180.401 6.7338L179.869 6.34082Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.223 6.48999L170.013 27.5507L170.412 27.8452L176.623 6.78445L176.223 6.48999Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.594 6.65015L166.433 27.4901L166.699 27.6869L172.861 6.84693L172.594 6.65015Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.988 27.5367L162.855 27.438L162.885 27.3276L168.945 6.79858L169.081 6.89733L169.047 7.00186L162.988 27.5367Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.28 27.38H159.276L165.307 6.94971V6.95548L159.28 27.38Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.18 4.33765L220.1 28.3271L222.351 29.9874L229.431 5.99785L227.18 4.33765Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.548 4.49951L216.53 28.2784L218.652 29.8429L225.67 6.06392L223.548 4.49951Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.899 4.64258L212.943 28.2109L214.931 29.6771L221.887 6.10874L219.899 4.64258Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.208 29.4081L209.392 28.2173L216.349 4.65015L218.161 5.84099L211.208 29.4081Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.62 4.94922L205.787 28.1017L207.509 29.3714L214.342 6.21894L212.62 4.94922Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.988 5.10864L202.217 28.0506L203.81 29.2245L210.581 6.28258L208.988 5.10864Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.338 5.26392L198.632 27.9971L200.091 29.0724L206.797 6.33921L205.338 5.26392Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.709 5.42041L195.062 27.9412L196.388 28.9186L203.035 6.39784L201.709 5.42041Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.065 5.56519L191.479 27.8806L192.671 28.7598L199.257 6.44443L198.065 5.56519Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.434 5.72656L187.908 27.8296L188.97 28.6134L195.497 6.51031L194.434 5.72656Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.788 5.87476L184.326 27.769L185.255 28.4543L191.717 6.55994L190.788 5.87476Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.14 6.02954L180.741 27.7133L181.537 28.3003L187.936 6.61651L187.14 6.02954Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.5 6.18213L177.164 27.6623L177.827 28.1508L184.163 6.67064L183.5 6.18213Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.869 6.34082L173.591 27.6087L174.124 28.0017L180.401 6.7338L179.869 6.34082Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.223 6.48999L170.013 27.5507L170.412 27.8452L176.623 6.78445L176.223 6.48999Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.594 6.65015L166.433 27.4901L166.699 27.6869L172.861 6.84693L172.594 6.65015Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.988 27.5367L162.855 27.438L162.885 27.3276L168.945 6.79858L169.081 6.89733L169.047 7.00186L162.988 27.5367Z",
  fill: "#FCEE0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.28 27.38H159.276L165.307 6.94971V6.95548L159.28 27.38Z",
  fill: "#FCEE0A"
}));

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M479.88 2.89394L481.164 4.93603L482.455 2.89394H479.88ZM571.192 7.59658H569.1L569.111 7.60824H571.181L571.192 7.59658ZM715.764 7.47988L713.365 3.65243H709.308L704.3 11.9958L704.293 11.9842V11.9958L701.407 7.60824H571.177L570.141 9.2536L571.873 11.9958H568.415L570.141 9.2536L569.104 7.60824H543.466L541.995 5.26276L539.091 0.647632L537.159 3.72244L527.353 3.65243H525.781L521.81 9.96541H511.259L508.984 6.35382L485.685 6.37714L483.877 9.2536L481.164 4.93603L480.258 6.37714L428.436 6.35382L424.431 0L416.885 11.9958L414.045 7.47988H412.839L412.181 8.52428L413.225 10.1872H411.137L412.177 8.52428L411.533 7.4974L390.222 7.47408V28H958V7.47408H715.764V7.47988ZM527.323 8.74016H526.781V7.87662H527.323V8.74016ZM527.323 7.00728H526.781V6.1438H527.323V7.00728ZM531.538 8.74016H530.999V6.1438H531.538V8.74016ZM533.622 7.00728H533.08V6.1438H533.622V7.00728ZM684.362 11.99H682.731V9.39362H684.362V11.99ZM689.797 11.99H689.254V9.39362H689.797V11.99ZM693.603 11.99H693.061V9.39362H693.603V11.99ZM694.427 11.99H693.88V9.39362H694.427V11.99Z",
  fill: "#39FF14"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M349.407 24.9651L350.693 26.9982L351.984 24.9651H349.411H349.407Z",
  fill: "#FCEE0A"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M224.146 27.4204H390.335V21.8902L390.377 9.45893V7.02494L355.322 7.04822L353.514 8.75024L350.809 5.61918L350.805 5.61337L349.898 7.04822L256.927 7.02494L254.178 2.97607H250.687L245.384 11.4805L242.543 6.98429H241.338L240.68 8.02411L241.723 9.67965H239.636L240.676 8.02411L240.033 7.00173L230.191 6.97846L224.146 27.4146V27.4204Z",
  fill: "#FCEE0A"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M224.146 27.4204H390.335V21.8902L390.377 9.45893V7.02494L355.322 7.04822L353.514 8.75024L350.809 5.61918L350.805 5.61337L349.898 7.04822L256.927 7.02494L254.178 2.97607H250.687L245.384 11.4805L242.543 6.98429H241.338L240.68 8.02411L241.723 9.67965H239.636L240.676 8.02411L240.033 7.00173L230.191 6.97846L224.146 27.4146V27.4204Z",
  fill: "#39FF14"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M125.771 7.14282L119.744 27.5673H252.769L258.8 7.14282H125.771Z",
  fill: "white"
});

var _ref78 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask5_823_282)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M227.18 4.33765L220.1 28.3271L222.351 29.9874L229.431 5.99785L227.18 4.33765Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.548 4.49951L216.53 28.2784L218.652 29.8429L225.67 6.06392L223.548 4.49951Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.899 4.64258L212.943 28.2109L214.931 29.6771L221.887 6.10874L219.899 4.64258Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.208 29.4081L209.392 28.2173L216.349 4.65015L218.161 5.84099L211.208 29.4081Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.62 4.94922L205.787 28.1017L207.509 29.3714L214.342 6.21894L212.62 4.94922Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.988 5.10864L202.217 28.0506L203.81 29.2245L210.581 6.28258L208.988 5.10864Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.338 5.26392L198.632 27.9971L200.091 29.0724L206.797 6.33921L205.338 5.26392Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.709 5.42041L195.062 27.9412L196.388 28.9186L203.035 6.39784L201.709 5.42041Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.065 5.56519L191.479 27.8806L192.671 28.7598L199.257 6.44443L198.065 5.56519Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.434 5.72656L187.908 27.8296L188.97 28.6134L195.497 6.51031L194.434 5.72656Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.788 5.87476L184.326 27.769L185.255 28.4543L191.717 6.55994L190.788 5.87476Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.14 6.02954L180.741 27.7133L181.537 28.3003L187.936 6.61651L187.14 6.02954Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.5 6.18213L177.164 27.6623L177.827 28.1508L184.163 6.67064L183.5 6.18213Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.869 6.34082L173.591 27.6087L174.124 28.0017L180.401 6.7338L179.869 6.34082Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.223 6.48999L170.013 27.5507L170.412 27.8452L176.623 6.78445L176.223 6.48999Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.594 6.65015L166.433 27.4901L166.699 27.6869L172.861 6.84693L172.594 6.65015Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.988 27.5367L162.855 27.438L162.885 27.3276L168.945 6.79858L169.081 6.89733L169.047 7.00186L162.988 27.5367Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.28 27.38H159.276L165.307 6.94971V6.95548L159.28 27.38Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.18 4.33765L220.1 28.3271L222.351 29.9874L229.431 5.99785L227.18 4.33765Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.548 4.49951L216.53 28.2784L218.652 29.8429L225.67 6.06392L223.548 4.49951Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.899 4.64258L212.943 28.2109L214.931 29.6771L221.887 6.10874L219.899 4.64258Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.208 29.4081L209.392 28.2173L216.349 4.65015L218.161 5.84099L211.208 29.4081Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.62 4.94922L205.787 28.1017L207.509 29.3714L214.342 6.21894L212.62 4.94922Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.988 5.10864L202.217 28.0506L203.81 29.2245L210.581 6.28258L208.988 5.10864Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.338 5.26392L198.632 27.9971L200.091 29.0724L206.797 6.33921L205.338 5.26392Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.709 5.42041L195.062 27.9412L196.388 28.9186L203.035 6.39784L201.709 5.42041Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.065 5.56519L191.479 27.8806L192.671 28.7598L199.257 6.44443L198.065 5.56519Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.434 5.72656L187.908 27.8296L188.97 28.6134L195.497 6.51031L194.434 5.72656Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.788 5.87476L184.326 27.769L185.255 28.4543L191.717 6.55994L190.788 5.87476Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.14 6.02954L180.741 27.7133L181.537 28.3003L187.936 6.61651L187.14 6.02954Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.5 6.18213L177.164 27.6623L177.827 28.1508L184.163 6.67064L183.5 6.18213Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.869 6.34082L173.591 27.6087L174.124 28.0017L180.401 6.7338L179.869 6.34082Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.223 6.48999L170.013 27.5507L170.412 27.8452L176.623 6.78445L176.223 6.48999Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.594 6.65015L166.433 27.4901L166.699 27.6869L172.861 6.84693L172.594 6.65015Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.988 27.5367L162.855 27.438L162.885 27.3276L168.945 6.79858L169.081 6.89733L169.047 7.00186L162.988 27.5367Z",
  fill: "#39FF14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.28 27.38H159.276L165.307 6.94971V6.95548L159.28 27.38Z",
  fill: "#39FF14"
}));

function SvgFaceHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 958,
    height: 955,
    viewBox: "0 0 958 955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_823_282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 930,
    width: 955,
    height: 25
  }, _ref53), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_823_282)"
  }, _ref54, _ref55, _ref56, _ref57, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_823_282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 675,
    y: 838,
    width: 164,
    height: 110
  }, _ref58), _ref59, _ref60, _ref61, _ref62, _ref63, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_823_282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 675,
    y: 838,
    width: 164,
    height: 110
  }, _ref64), _ref65), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_823_282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 958,
    height: 25
  }, _ref66), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_823_282)"
  }, _ref67, _ref68, _ref69, _ref70, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_823_282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 7,
    width: 165,
    height: 110
  }, _ref71), _ref72, _ref73, _ref74, _ref75, _ref76, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_823_282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 7,
    width: 165,
    height: 110
  }, _ref77), _ref78));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceHero);
export default __webpack_public_path__ + "static/media/face-hero.94678e1e.svg";
export { ForwardRef as ReactComponent };